import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import { json, useParams } from 'react-router-dom'
import { GetEType } from '../../../configurations/enums/EType'
import { MdDriveFileRenameOutline, MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { FaNotesMedical, FaPhone } from "react-icons/fa6";
import { MdBloodtype } from "react-icons/md";
import { GiWeightScale } from "react-icons/gi";
import { FaPerson } from "react-icons/fa6";
import { FaAddressCard } from "react-icons/fa";
import { MdOutlineLocalPhone } from "react-icons/md";
import { PrintStarterDash } from '../settings/Prints/PrintStaterDash'
import { ConfirmOpdPrint } from '../settings/Prints/ConfirmOpdPrint'
import { PrescriptionLetterPrint } from '../settings/Prints/PrescriptionLetterPrint'
import { GetEGender } from '../../../configurations/enums/EGender'
import Select from '../../controls/Select'
import { BiSolidDonateBlood } from "react-icons/bi";
import { BsGenderAmbiguous } from "react-icons/bs";
import { TbCategoryPlus } from "react-icons/tb";
import { IsMobileEnv } from '../../../configurations/initUrls'

const schema = yup.object().shape({
    patientName: yup.string().required("Patient Name is required."),
    mobile: yup.string().matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits').required('Mobile number is required'),
    patientAddress: yup.string().min(3, "Address must minimum 3 characters").required("Patient Address is required."),
    bloodGroup: yup.string().required("Blood Group is required."),
    bloodPressure: yup.string().required("Blood Pressure is required."),
    weight: yup.string().matches(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/, 'Should be digit.').required("Weight is required."),
    age: yup.string().matches(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/, 'Should be positive number.').required("Age is required."),
    type: yup.string().required("Type is required."),
    gender: yup.string().required("Gender is required."),
    patientBond: yup.string().required("Bond is required"),
    patientType: yup.string().required("Type is required"),
})

export default function AddOpdOffline({ isOpen, setIsOpen, addOpdOffline, loding, currentSavedData, isPrint, setIsPrint }) {
    const { centerid } = useParams()
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    // const [cityData, setCityData] = useState([]);
    // const [stateData, setStateData] = useState([])
    const toast = useToast()

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            opdCenterId: centerid,
            patientName: "",
            mobile: "",
            bloodGroup: "N/A",
            bloodPressure: "",
            weight: "",
            age: "",
            gender: 0,
            type: 0,
            note: "",
            // cityId: "",
            // stateId: "",
            patientBond: "Cash",
            patientType: "Normal",
            patientAddress: ""
        },
        validationSchema: schema,
        onSubmit(val) {
            addOpdOffline(val, setValues)
        }
    })
    const printRef = useRef();
    const printLetterRef = useRef();
    useEffect(() => {
        if (values.type == 1) setValues({ ...values, patientType: 'Emergency' })
        else setValues({ ...values, patientType: 'Normal' })
    }, [values.type])
    useEffect(() => {
        if (values.patientType == 'Emergency') setValues({ ...values, type:1 })
        else setValues({ ...values, type: 0 })
    }, [values.patientType])
    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={isPrint ? "Print Opd" : "Add New OPD"}>
            {isPrint ?
                <div class="p-6 space-y-6">
                    {currentSavedData &&
                        <div className='flex flex-col items-center justify-center gap-3'>
                            {IsMobileEnv &&
                                <div className='flex items-center justify-center gap-3'>
                                    <h1 className='text-2xl text-green-500'>OPD Created Successfully.</h1>
                                </div>
                            }
                            <div className='flex items-center justify-center gap-3'>
                                <div>
                                    <PrintStarterDash printRef={printRef} text='Print Slip' close={(t) => { setIsPrint(t); setIsOpen(t) }} />
                                </div>
                                <div>
                                    <PrintStarterDash printRef={printLetterRef} text='Print Prescription Letter' close={(t) => { setIsPrint(t); setIsOpen(t) }} />
                                </div>
                            </div>
                            <div style={{ display: "none" }}>
                                <ConfirmOpdPrint printData={currentSavedData} ref={printRef} />
                                <PrescriptionLetterPrint printData={currentSavedData} ref={printLetterRef} />
                            </div>
                        </div>
                    }
                </div>
                :
                <form onSubmit={handleSubmit}>
                    <div class="p-6 space-y-6">
                        <div class="grid grid-cols gap-6">

                            <div class="md:col-span-2 col-span-4">
                                <label for="patientName" class="block mb-2 text-sm font-medium text-gray-900">Patient Name</label>
                                <Input placeholder="Patient Name"
                                    id="patientName"
                                    Icon={<MdDriveFileRenameOutline className='text-green-600 text-lg' />}
                                    value={values.patientName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.patientName && touched.patientName}
                                />
                                {errors.patientName && touched.patientName && <p className='text-red-600 text-xs'>{errors.patientName}</p>}
                            </div>

                            <div class="md:col-span-2 col-span-4">
                                <label for="mobile" class="block mb-2 text-sm font-medium text-gray-900">Mobile</label>
                                <Input placeholder="Mobile"
                                    id="mobile"
                                    Icon={<MdOutlineLocalPhone className="text-blue-600 text-lg" />}
                                    value={values.mobile}
                                    pattern="\d{10}"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.mobile && touched.mobile}
                                />
                                {errors.mobile && touched.mobile && <p className='text-red-600 text-xs'>{errors.mobile}</p>}
                            </div>
                            <div class="col-span-4">
                                <label for="patientAddress" class="block mb-2 text-sm font-medium text-gray-900">Patient Address</label>
                                <Input placeholder="Patient Address"
                                    id="patientAddress"
                                    Icon={<FaAddressCard className='text-brand-500 text-lg' />}
                                    value={values.patientAddress}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.patientAddress && touched.patientAddress}
                                />
                                {errors.patientAddress && touched.patientAddress && <p className='text-red-600 text-xs'>{errors.patientAddress}</p>}
                            </div>

                            <div className='md:col-span-4 col-span-4'>
                                <div className='flex flex-col md:flex-row w-full gap-6'>
                                    <div className='w-full' >
                                        <label for="gender" class="block mb-2 text-sm font-medium text-gray-900 ">Gender</label>
                                        <Select
                                            Icon={<BsGenderAmbiguous className='text-orange-600 text-lg' />}
                                            id="gender"
                                            value={values.gender}
                                            onChange={handleChange}
                                            onBlur={handleBlur}>
                                            {GetEGender.EGender.map((items, index) =>
                                                <option value={items.Id}>{items.Name}</option>
                                            )}
                                        </Select>
                                    </div>
                                    <div className='w-full'>
                                        <label for="weight" class="block mb-2 text-sm font-medium text-gray-900">Weight</label>
                                        <Input placeholder="Weight"
                                            id="weight"
                                            type="text"
                                            Icon={<GiWeightScale className='text-amber-900 text-lg' />}
                                            value={values.weight}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.weight && touched.weight}
                                        />
                                        {errors.weight && touched.weight && <p className='text-red-600 text-xs'>{errors.weight}</p>}
                                    </div>

                                    <div className='w-full' >
                                        <label for="age" class="block mb-2 text-sm font-medium text-gray-900">Age</label>
                                        <Input placeholder="Age"
                                            id="age"
                                            type="text"
                                            Icon={<FaPerson className='text-teal-600 text-lg' />}
                                            value={values.age}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isError={errors.age && touched.age}
                                        />
                                        {errors.age && touched.age && <p className='text-red-600 text-xs'>{errors.age}</p>}
                                    </div>
                                </div>
                            </div>
                            <div class="md:col-span-2 col-span-4">
                                <label for="bloodGroup" class="block mb-2 text-sm font-medium text-gray-900">Blood Group</label>
                                <Select
                                    Icon={<MdBloodtype className='text-red-600 text-lg' />}
                                    id="bloodGroup"
                                    name="bloodGroup"
                                    value={values.bloodGroup}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.bloodGroup && touched.bloodGroup}
                                >
                                    <option value="N/A">N/A</option>
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                </Select>
                                {errors.bloodGroup && touched.bloodGroup && <p className='text-red-600 text-xs'>{errors.bloodGroup}</p>}
                            </div>

                            <div class="md:col-span-2 col-span-4">
                                <label for="bloodPressure" class="block mb-2 text-sm font-medium text-gray-900">Blood Pressure</label>
                                <Input placeholder="Blood Pressure"
                                    id="bloodPressure"
                                    Icon={<BiSolidDonateBlood className="text-blue-600 text-lg" />}
                                    value={values.bloodPressure}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.bloodPressure && touched.bloodPressure}
                                />
                                {errors.bloodPressure && touched.bloodPressure && <p className='text-red-600 text-xs'>{errors.bloodPressure}</p>}
                            </div>
                            <div class="md:col-span-2 col-span-4">
                                <label for="type" class="block mb-2 text-sm font-medium text-gray-900">OPD Type</label>
                                <Select
                                    Icon={<TbCategoryPlus className='text-teal-600 text-lg' />}
                                    id="type"
                                    value={values.type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    {GetEType.EType.map((item) =>
                                        <option value={item.Id}>{item.Name}</option>
                                    )}
                                </Select>
                            </div>

                            <div class="md:col-span-2 col-span-4">
                                <label for="note" class="block mb-2 text-sm font-medium text-gray-900">Note</label>
                                <Input placeholder="Note"
                                    id="note"
                                    Icon={<FaNotesMedical className='text-orange-300 text-lg' />}
                                    value={values.note}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.note && touched.note}
                                />
                                {errors.note && touched.note && <p className='text-red-600 text-xs'>{errors.note}</p>}
                            </div>
                            <div class="md:col-span-2 col-span-4">
                                <label htmlFor="patientType" className="block mb-2 text-sm font-medium text-gray-900">
                                    Patient Type
                                </label>
                                <Select
                                    Icon={'@'}
                                    id="patientType"
                                    name="patientType"
                                    value={values.patientType}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.patientType && touched.patientType}
                                    disabled={values.type == 0 ? false : true}
                                >
                                    <option value="Normal">Normal</option>
                                    <option value="New">New</option>
                                    <option value="Under NF">Under NF</option>
                                    <option value="Emergency">Emergency</option>
                                </Select>
                                {errors.patientType && touched.patientType && (
                                    <p className="text-red-600 text-xs">{errors.patientType}</p>
                                )}
                            </div>
                            <div class="md:col-span-2 col-span-4">
                                <label htmlFor="patientBond" className="block mb-2 text-sm font-medium text-gray-900">
                                    Bond
                                </label>
                                <Select
                                    Icon={'@'}
                                    id="patientBond"
                                    name="patientBond"
                                    value={values.patientBond}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.patientBond && touched.patientBond}
                                >
                                    <option value="Cash">Cash</option>
                                    <option value="UPI">UPI</option>
                                </Select>
                                {errors.patientBond && touched.patientBond && (
                                    <p className="text-red-600 text-xs">{errors.patientBond}</p>
                                )}
                            </div>



                        </div>
                    </div>
                    <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                        {!loding ?
                            <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                            : <LodingButton text="Wait.." />
                        }
                    </div>
                </form>
            }
        </Modal>

    )
}

